import React from 'react';
import {
  ListItem,
  ListItemButton,
  ListItemText,
  alpha,
  useTheme,
} from '@mui/material';

const TemplateListItem = ({
  filteredList,
  pageNumber,
  pageLength,
  handleSelect,
}) => {
  const theme = useTheme();
  const displayList = filteredList.slice(
    (pageNumber - 1) * pageLength,
    pageNumber * pageLength
  );

  return displayList.map((element) => (
    <ListItem
      key={element.template_sms_id}
      disablePadding
      sx={{
        '&:nth-of-type(even)': {
          backgroundColor: alpha(theme.palette.secondary.light, 0.15),
        },
      }}>
      <ListItemButton onClick={() => handleSelect(element)}>
        <ListItemText
          id={element.template_sms_id}
          primary={element.template_name}
        />
      </ListItemButton>
    </ListItem>
  ));
};

export default TemplateListItem;
